import React, { useState } from 'react';
import { X, MapPin, CheckCircle } from 'lucide-react';
import C from '../../constants/colors';

export default function SiteCheckInModal({ employee, companies, sites, zones, onCheckIn, onClose }) {
  const [selectedSiteId, setSelectedSiteId] = useState('');
  const [selectedZoneId, setSelectedZoneId] = useState('');

  // Sites this employee can access
  const empCompany = companies.find(c => c.id === employee.companyId);
  const accessibleSites = sites.filter(s => {
    if (s.companyId === employee.companyId) return true;
    if (!employee.allowedOtherCompanies) return false;
    const siteCompany = companies.find(c => c.id === s.companyId);
    return siteCompany?.orgId === empCompany?.orgId;
  });

  const zonesForSite = zones.filter(z => z.siteId === selectedSiteId);

  function handleConfirm() {
    if (!selectedSiteId) return;
    onCheckIn({ siteId: selectedSiteId, zoneId: selectedZoneId || null });
    onClose();
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.surfaceElevated, border: `1px solid ${C.border}`, borderRadius: '16px', padding: '28px', width: '420px', maxWidth: '95vw' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div>
            <h3 style={{ fontSize: '16px', fontWeight: 700, color: C.textPrimary, margin: 0 }}>Check In</h3>
            <div style={{ fontSize: '12px', color: C.textMuted, marginTop: '2px' }}>{employee.name} · {employee.employeeId}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.textMuted }}><X size={18} /></button>
        </div>

        {/* Site selection */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontSize: '11px', color: C.textMuted, marginBottom: '6px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Select Site *</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {accessibleSites.map(s => {
              const co = companies.find(c => c.id === s.companyId);
              const selected = selectedSiteId === s.id;
              return (
                <div key={s.id} onClick={() => { setSelectedSiteId(s.id); setSelectedZoneId(''); }}
                  style={{ padding: '10px 14px', borderRadius: '10px', border: `1px solid ${selected ? C.blue : C.border}`, background: selected ? C.blue+'22' : C.surface, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <MapPin size={14} color={selected ? C.blue : C.textMuted} />
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: 600, color: selected ? C.blue : C.textPrimary }}>{s.name}</div>
                    <div style={{ fontSize: '11px', color: C.textMuted }}>{co?.name}</div>
                  </div>
                  {selected && <CheckCircle size={14} color={C.blue} style={{ marginLeft: 'auto' }} />}
                </div>
              );
            })}
          </div>
        </div>

        {/* Zone selection (optional) */}
        {selectedSiteId && zonesForSite.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: '11px', color: C.textMuted, marginBottom: '6px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Select Zone <span style={{ color: C.textMuted, fontWeight: 400, textTransform: 'none' }}>(optional)</span></label>
            <select value={selectedZoneId} onChange={e => setSelectedZoneId(e.target.value)}
              style={{ width: '100%', background: C.surface, border: `1px solid ${C.border}`, borderRadius: '8px', padding: '8px 12px', color: C.textPrimary, fontSize: '13px', fontFamily: 'inherit', outline: 'none' }}>
              <option value=''>No specific zone</option>
              {zonesForSite.map(z => <option key={z.id} value={z.id}>{z.name} — Floor {z.floor}</option>)}
            </select>
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '9px 20px', borderRadius: '8px', border: `1px solid ${C.border}`, background: 'transparent', color: C.textSecondary, fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          <button onClick={handleConfirm} disabled={!selectedSiteId}
            style={{ padding: '9px 20px', borderRadius: '8px', border: 'none', background: selectedSiteId ? C.green : C.border, color: selectedSiteId ? '#fff' : C.textMuted, fontSize: '13px', fontWeight: 600, cursor: selectedSiteId ? 'pointer' : 'default', fontFamily: 'inherit' }}>
            Check In
          </button>
        </div>
      </div>
    </div>
  );
}
